import { Download } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useCRUD } from "../../api/crud";
import { usePurchaseInvoices } from "../../api/invoices";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { ERROR_SNACKBAR, PURCHASE_INVOICES_ENDPOINT } from "../../consts";
import { PurchaseInvoice } from "../../types/invoices";
import { Action } from "../../types/toolbar";

export const PurchaseInvoiceDetailsActions = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { get } = useCRUD(PURCHASE_INVOICES_ENDPOINT);
  const { downloadPurchaseInvoiceXml, loading } = usePurchaseInvoices();
  const [invoice, setInvoice] = useState<PurchaseInvoice | null>(null);

  useEffect(() => {
    if (!id) {
      return;
    }
    get(id).then((response) => setInvoice(response?.data ?? null));
  }, [id, get]);

  if (!invoice || !id) {
    return null;
  }

  const actions: Action[] = [
    {
      id: "download-purchase-invoice-xml",
      icon: <Download />,
      label: t("Download XML"),
      onClick: async () => {
        // The first download is fetched from KSeF, which caps downloads per
        // hour - its refusal carries the reason, so it is shown as-is.
        const result = await downloadPurchaseInvoiceXml(id, invoice);
        if (!result.success) {
          enqueueSnackbar(
            result.message || t("Could not download the XML"),
            ERROR_SNACKBAR
          );
        }
      },
      disabled: loading,
    },
  ];

  return <Toolbar actions={actions} />;
};
